export const LANG = {
  KR: 'KR',
  TW: 'TW',
  EN: 'EN',
}